module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/4-3ba8c28d604cb76be0f75961b2967a2c.jpg";